module.exports = __webpack_public_path__ + "img/logo.7923eba4.png";